<template>
    <section>
      <div id="qingkuandan">
      <table rules="all" frame="box" class="record-table">
        <tr>
          <td class="table-title">业务类型</td>
          <td colspan="8" class="td-checkbox">
            <div style="margin-left: 10px;">
<!--              <el-checkbox-group v-model="sendData.checkedOccurred" @change="handleCheckedTypeChange" :disabled="applicationForm.isApplyRecord">-->
<!--                <el-checkbox v-for="(item,index) in dictionaryLists['account_request']" :label="item.code" :key="index">{{item.value}}</el-checkbox>-->
<!--              </el-checkbox-group>-->
              <template v-if="this.applicationForm.processId && (this.applicationForm.processId == '952440d93ccf4215bf4daa06a92a079f' || this.applicationForm.processId == '1717366929410228224' )">
                业务成本
              </template>
              <template v-else>
              {{applicationForm.exter&&applicationForm.exter.businessType?applicationForm.exter.businessType:applicationForm.businessType?applicationForm.businessType:''}}
              </template>
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-title">付款方式</td>
          <td colspan="8" class="td-checkbox">
            <div style="margin-left: 10px;display: flex;">
              <el-checkbox-group v-model="sendData.checkedSettlement" :disabled="applicationForm.isApplyRecord">
                <el-checkbox @change="handleCheckedChange(item)" v-for="(item,index) in dictionaryLists['settlement_type']" :label="item.code" :key="index">
                  <div style="display: flex;">
                    <div style="margin-right: 5px;">{{item.value}}</div>
                    <div :style="sendData.checkedSettlement[0]==4?'':'display: none;'">
                      <input v-if="item.code == 4" class="checkInput" placeholder="请输入支票号" v-model="sendData.paybillValue" :disabled="applicationForm.isApplyRecord"/>
                    </div>
                  </div>
                </el-checkbox>
              </el-checkbox-group>
              <el-checkbox style="margin-left: 40px;" v-model="sendData.billChecked" :disabled="applicationForm.isApplyRecord">
                <div style="display: flex;">
                  <div :style="sendData.billChecked?'':'display: none;'">
                    <select class="checkInput2" v-model="sendData.billValue" :disabled="applicationForm.isApplyRecord" v-if="!applicationForm.isApplyRecord">
                      <option v-for="(item,index) in dictionaryLists['bill_status']" :value="item.code">{{item.value}}</option>
                    </select>
                    <input :disabled="applicationForm.isApplyRecord" v-if="applicationForm.isApplyRecord" class="checkInput2" :value="statusFmt(null,null,sendData.billValue,null)"/>
<!--                    <div style="width: 40px;text-align: center" v-if="applicationForm.isApplyRecord">{{statusFmt(null,null,sendData.billValue,null)}}</div>-->
                  </div>
                  <div style="margin-left: 5px;">发票</div>
                </div>
              </el-checkbox>
            </div>
          </td>
        </tr>
        <template v-if="sendData.checkedSettlement.indexOf(3) >= 0">
        <tr v-if="!applicationForm.isApplyRecord">
          <td class="table-title">承兑汇票</td>
          <td colspan="8" class="td-checkbox">
            <div style="margin-right: 10px;margin-left: 10px;">{{selectedAcceptanceDesc}}</div>
          </td>
        </tr>
        <tr v-if="applicationForm.isApplyRecord && baseComponent.datas">
          <td class="table-title">承兑汇票</td>
          <td colspan="8" class="td-checkbox">
            <div style="margin-right: 10px;margin-left: 10px;">{{baseComponent.datas.params5}}</div>
          </td>
        </tr>
        </template>

        <tr>
          <td class="table-title">请款单位<span v-if="applicationForm.accountingType == 1">(山东公司)</span> </td>
          <td colspan="8" class="td-checkbox">
<!--            <div style="display:flex;">-->
<!--              <div style="margin-right: 10px;margin-left: 10px;">-->
<!--                <el-checkbox-group v-model="sendData.checkList" :disabled="applicationForm.isApplyRecord">-->
<!--                  <el-checkbox @change="CheckedChange(1)" :label="Number(1)">海南合盛</el-checkbox>-->
<!--                  <el-checkbox @change="CheckedChange(2)" :label="Number(2)">海南成功</el-checkbox>-->
<!--                  <el-checkbox @change="CheckedChange(3)" :label="Number(3)">分公司</el-checkbox>-->
<!--                </el-checkbox-group>-->
<!--              </div>-->
<!--              <div style="display: flex;">-->
<!--                <div style="margin-right: 10px;">(</div>-->
<!--                <div style="margin-right: 10px;">-->
<!--                  <el-checkbox-group v-model="sendData.checkboxNewList" :disabled="sendData.checkList[0]!=3 || applicationForm.isApplyRecord">-->
<!--                    <el-checkbox @change="CheckedChangeNew(4)" :label="Number(4)">成功</el-checkbox>-->
<!--                    <el-checkbox @change="CheckedChangeNew(5)" :label="Number(5)">合盛</el-checkbox>-->
<!--                  </el-checkbox-group>-->
<!--                </div>-->
<!--                <div>)</div>-->
<!--              </div>-->
<!--            </div>-->
            <div style="margin-right: 10px;margin-left: 10px;">{{contractCompanyFmt(null,null,applicationForm.invoiceCompany,null)}}</div>
          </td>
        </tr>
        <tr>
          <td class="table-title" rowspan="3">收款方</td>
          <td>全称</td>
          <td colspan="7">{{formValue && formValue.bak_full_name ? formValue.bak_full_name :contract != null ?contract.accountName:"--"}}</td>
<!--          <td class="td-func" >-->
<!--            <el-button size="small" type="text" v-if="applicationForm.isApplyRecord">截图</el-button>-->
<!--          </td>-->
        </tr>
        <tr>
          <td>账号</td>
          <td colspan="7">{{formValue && formValue.bak_bank_number ? formValue.bak_bank_number :contract != null ?contract.cardNumber:"--"}}</td>
<!--          <td class="td-func">-->
<!--            <el-button size="small" type="text" v-if="applicationForm.isApplyRecord" @click="printApply">打印</el-button>-->
<!--          </td>-->
        </tr>
        <tr>
          <td>地址</td>
          <td class="td-address">{{formValue && formValue.bak_address_province? formValue.bak_address_province.replace('省','')  :contract.province != null ?contract.province:(contract.address != null?contract.address.substring(0,contract.address.indexOf('省')):"")}}省</td>
          <td class="td-address">{{formValue && formValue.bak_address_city ? formValue.bak_address_city.replace('市','')  :contract.city != null ?contract.city:(contract.address != null?contract.address.substring(contract.address.indexOf('省')+1,contract.address.indexOf('市')):"")}}市(县)</td>
          <td class="td-func">开户行</td>
          <td colspan="4">{{formValue && formValue.bak_bank_name ? formValue.bak_bank_name :contract != null ?contract.openingBank:"--"}}</td>
        </tr>
        <tr class="row-price">
          <td class="table-title">金额(大写)</td>
          <td colspan="5">{{revertNum(pay)}}</td>
          <td colspan="2">
            <table rules="all" cellspacing=0 cellpadding=0 class="price-table">
              <tr style="line-height: 20px;height: 20px;">
                <td>千</td>
                <td>百</td>
                <td>十</td>
                <td>万</td>
                <td>千</td>
                <td>百</td>
                <td>十</td>
                <td>元</td>
                <td>角</td>
                <td>分</td>
              </tr>
              <tr style="line-height: 20px;height: 20px;">
                <td>{{priceNum.numQianWan}}</td>
                <td>{{priceNum.numBaiWan}}</td>
                <td>{{priceNum.numShiWan}}</td>
                <td>{{priceNum.numWan}}</td>
                <td>{{priceNum.numQian}}</td>
                <td>{{priceNum.numBai}}</td>
                <td>{{priceNum.numShi}}</td>
                <td>{{priceNum.numYuan}}</td>
                <td>{{priceNum.numJiao}}</td>
                <td>{{priceNum.numFen}}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>请款说明</td>
          <td colspan="9" style="text-align: left;">
            <span v-if="applicationForm.isApplyRecord">

              <span class="pt-show">{{ applicationForm.remark }}</span>
              <span class="pt-print">{{ applicationForm.remark && applicationForm.remark.replace(/\#.*\#/g, '') }}</span>
            </span>
            <span v-if="!applicationForm.isApplyRecord" style="color:#5c95f2; cursor: pointer" @click="editRemark">
              {{applicationForm.remark}}
            </span>
          </td>
        </tr>
        <tr>
          <td style="text-align: left;width: 70%;" colspan="7">
            <div style="display: flex;">
              <div class="td-mar">申请人：{{userName}}</div>
              <div class="td-mar">商务审批：{{spPeoples1}}</div>
              <div class="td-mar">业务经理：{{spPeoples2}}</div>
              <div class="td-mar">往来会计：{{spPeoples8}}</div>
            </div>
          </td>
          <td style="text-align: left;width: 30%;" rowspan="2" colspan="3">
            公司负责人:{{spPeoples6}}
          </td>
        </tr>
        <tr>
          <td style="text-align: left;width: 70%;"  colspan="7">
            <div style="display: flex;">
              <div class="td-mar">财务总监：{{spPeoples5}}</div>
              <div class="td-mar">总经理：{{spPeoples4}}</div>
              <div class="td-mar">出纳：{{spPeoples7}}</div>
              <div class="td-mar">会计：{{spPeoples3}}</div>
            </div>
          </td>
        </tr>
      </table>
      </div>

      <el-dialog
        title="选择承兑汇票"
        :visible.sync="acceptanceVisible"
        width="90%"
          :show-close="false"
        @opened="acceptanceOpened"
        :append-to-body="true"
        :before-close="handleClose">
        <el-row :gutter="20">
          <el-col :span="12">已选择：{{selectedAcceptanceSum}} / {{pay}}</el-col>
          <el-col :span="12" style="text-align: right;">
            <el-button @click="acceptanceOpened(true)" type="text" :disabled="loadingAcceptanceList" :loading="loadingAcceptanceList">刷新承兑汇票</el-button>
          </el-col>
        </el-row>
        <el-table
          :data="acceptanceList"
          v-loading="loadingAcceptanceList"
          :row-class-name="selectedAcceptanceClassName"
          size="mini"
          height="50vh"
          @row-click="checkRow"
          border>
           <el-table-column
            key="0"
            width="35"
            fixed>
            <template slot-scope="scope"><img :class="!scope.row.checked?'showpic':''" style="width: 14px;vertical-align: middle;" src="@/assets/img/yixuanze.png"/></template>
          </el-table-column>
          <el-table-column
            label="账户">
            <template slot-scope="scope">
              <span>{{scope.row.bankName}}<br/>{{scope.row.bankNum}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="ticketNumber"
            label="票号">
          </el-table-column>
          <el-table-column
            prop="balance"
            width="120"
            label="金额">
          </el-table-column>
          <el-table-column
            prop="customerName"
            label="背书人">
          </el-table-column>
          <el-table-column
            prop="acceptorName"
            label="承兑人">
          </el-table-column>
          <el-table-column
            prop="votingDate"
            width="90"
            :formatter="(row, column, cellValue, index) => { return myFmtDateTime(cellValue,'YYYY/MM/DD')}"
            label="出票日">
          </el-table-column>
          <el-table-column
            prop="expireDate"
            width="90"
            :formatter="(row, column, cellValue, index) => { return myFmtDateTime(cellValue,'YYYY/MM/DD')}"
            label="到期日">
          </el-table-column>

        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancelAcceptance">取消选择承兑汇票</el-button>
            <el-button type="primary" @click="confirmAcceptance">确 定</el-button>
          </span>
      </el-dialog>

      <div v-if="applicationForm.isApplyRecord" style="margin-top: 10px;">
        <span>备注：{{ applicationForm.textContent||'--' }}</span>
        <br>
        附件：<file-list :value="applicationForm.fileList"></file-list>
      </div>
      <div v-if="!applicationForm.isApplyRecord" style="margin-top: 10px;display: flex;">
        备注：
        <el-input
          type="textarea"
          :rows="6"
          style="width:500px;"
          placeholder="请输入备注内容"
          v-model="textContent">
        </el-input>
        &nbsp;
        附件：<pic-upload v-model="fileList" >
              <template v-slot:trigger>
                <el-button>点击上传</el-button>
              </template>
        </pic-upload>
      </div>

    </section>
</template>

<script>
    import {getDictionaryList} from "../../api/sysdictionary";
    import {ERR_OK} from "../../jslib/config";
    import {getSysSupplierContactList, unusedAcceptances} from "../../api/syssupplier";
    import Select from "../esform/units/select";
    import {fmtDictionary,fmtDictionarySpare} from "../../jslib/util";
    import {getUserInfoById} from "../../api/user";
    import dayjs from "dayjs";
    import {getPersonalListById} from "../../api/syscustomersecondlevelperson";
    import FileList from "@/components/filelist/index.vue";
    import PicUpload from "@/components/pic-upload2/index.vue";
    const processApi = require('@/api/process')

    export default {
        name: "ExternalAccountRequest",
      components: {Select,FileList,PicUpload},

      computed: {
        selectedAcceptanceSum() {
          let sum = 0;
          this.acceptanceList.forEach(item => {
            if (item.checked) {
              sum += item.balance;
            }
          });

          return sum.toFixed(2);
        },
        selectedAcceptance() {
          let list = [];
          this.acceptanceList.forEach(item => {
            if (item.checked) {
              list.push(item);
            }
          });
          return list;
        },
        selectedAcceptanceDesc() {
          let desc = '';
          this.selectedAcceptance.forEach(item => {
            desc += `票号:${item.ticketNumber},金额:${item.balance};`
          });
          return desc;
        },
        selectedAcceptanceNums() {
          let nums = '';
          const list = this.selectedAcceptance;
          if (list && list.length == 0) {
            return nums;
          }
          list.forEach(item => {
            nums += `,${item.ticketNumber}`
          });

          return nums.substr(1);
        }
      },
      props: {
          applyObj:{
            type: Object
          },
        },
        data() {
          return {
              formValue:{},
              baseComponent: null,
              acceptanceVisible: false,
              dictionaryLists:[],
              acceptanceList:[],
              loadingAcceptanceList:false,
              sendData:{
                checkedSettlement:[],
                billChecked:false,
                billValue:null,
                paybillValue:null,
              },
              contractList:[],
              applicationForm:{},
              contract:{},
              pay:0,
              priceNum:{
                numQianWan:0,
                numBaiWan:0,
                numShiWan:0,
                numWan:0,
                numQian:0,
                numBai:0,
                numShi:0,
                numYuan:0,
                numJiao:0,
                numFen:0,
              },
              userName:null,
              spPeoples1: null,
              spPeoples2: null,
              spPeoples3: null,
              spPeoples4: null,
              spPeoples5: null,
              spPeoples6: null,
              spPeoples7: null,
              spPeoples8: null,
            fileList: [],
            textContent:''
            };
        },
        mounted() {
          getDictionaryList("account_request,settlement_type,bill_status,contract_company").then(res=>{
            if (res!=undefined&&res.resultCode === ERR_OK) {
              this.dictionaryLists = res.map
            }
          })
          this.$on('onBeforeSubmit', (cb) => {
            cb(this.beforeSubmit())
          })
        },
        methods: {
          beforeSubmit() {
            if (this.sendData.checkedSettlement[0] == 3 && this.selectedAcceptance.length > 0) {
              this.baseComponent.globalParams.params5 = this.selectedAcceptanceDesc
              this.baseComponent.formValue.acceptanceNums = this.selectedAcceptanceNums
            } else {
              delete this.baseComponent.globalParams.params5
              delete this.baseComponent.formValue.acceptanceNums
            }
            this.baseComponent.formValue.textContent = this.textContent
            this.baseComponent.formValue.fileList = this.fileList
            return true;
          },
          cancelAcceptance() {
            this.sendData.checkedSettlement=[];
            this.acceptanceVisible = false;
          },
          confirmAcceptance() {
            if (this.selectedAcceptanceSum < this.pay) {
              this.$message.error(`选择的承兑汇票总金额[${this.selectedAcceptanceSum}]不足[${this.pay}]`)
              return;
            } else if (this.selectedAcceptanceSum > this.pay) {
              this.$message.error(`选择的承兑汇票总金额[${this.selectedAcceptanceSum}]超出了[${this.pay}]`)
              return;
            }
            this.acceptanceVisible = false;
          },
          handleClose() {
            this.sendData.checkedSettlement=[];
            this.acceptanceVisible = false
          },
          editRemark() {
            this.$prompt('编辑请款说明', '请款说明', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputType: 'textarea',
              closeOnClickModal: false,
              inputValue:this.applicationForm.remark
            }).then(({value}) => {
              this.applicationForm.remark = value
            }).catch(() => {
            });
          },
          getUserNameById(id){
            getUserInfoById(id).then(res=>{
              if (res!=undefined&&res.resultCode === ERR_OK && !!res.user) {
                this.userName =  res.user.name
              }
            })
          },
          getSpPerson(){
            processApi.getSpPerspnNoPage(this.applicationForm.processId).then(res => {
              if (!!res.list){
                for(var i=0;i<res.list.length;i++){
                  var tmp = res.list[i]
                  if(tmp.nodeId == 10){
                    this.spPeoples1 = tmp.userName
                  } else if(tmp.nodeId == 20){
                    this.spPeoples2 = tmp.userName
                  } else if(tmp.nodeId == 30){
                    this.spPeoples3 = tmp.userName
                  } else if(tmp.nodeId == 40){
                    this.spPeoples4 = tmp.userName
                  } else if(tmp.nodeId == 50){
                    this.spPeoples5 = tmp.userName
                  } else if(tmp.nodeId == 60 || tmp.nodeId == 70){
                    this.spPeoples6 = tmp.userName
                  }  else if(Math.floor(tmp.nodeId/10) == 8){
                    this.spPeoples7 = tmp.userName
                  } else if(tmp.nodeId == 25){
                    this.spPeoples8 = tmp.userName
                  }
                }
              }
            }).catch(e => {

            })
          },
          printApply(){
            $("input").each(function(){
              $(this).attr('value',$(this).val());
            });
                 let checkEle = window.document.getElementsByClassName('checkInput2')
            checkEle[0].setAttribute('value', checkEle[0].value)
            var html = window.document.body.innerHTML
            var str = window.document.getElementById("qingkuandan").innerHTML
            window.document.body.innerHTML=str;
            window.print();
            window.location.reload()
          },
          handleCheckedTypeChange(value) {
          },
          handleCheckedChange(item) {
            if(this.sendData.checkedSettlement.length>0){
              this.sendData.checkedSettlement = []
              this.sendData.checkedSettlement.push(item.code)
            }
            if (item.code == 3) {
              // this.sendData.checkedSettlement 是否包含“3”
              if (this.sendData.checkedSettlement.indexOf(3) == -1) {
                // 若包含：说明是“承兑汇票”被选中的情况下，又点击一次
                // 这时，我们再把3放入数组，来实现保持选中并打开弹框的效果
                this.sendData.checkedSettlement.push(3)
              }
              // 弹框
              this.$nextTick(() => {
                this.acceptanceVisible = true
              })
            }
          },
          checkRow(row, column, event){
            row.checked = !row.checked
          },
          selectedAcceptanceClassName({row, rowIndex}) {
            if (row.checked) {
              return 'selected-row'
            }
            return ''
          },
          acceptanceOpened(refresh = false) {
            if (refresh == false) {
              if (this.acceptanceList && this.acceptanceList.length > 0) {
                return;
              }
            }
            this.loadingAcceptanceList = true
            unusedAcceptances(this.applicationForm.accountingType).then(res=>{
              const list = res.list.map(item=>{
                item.checked = false;
                return item
              });
              this.acceptanceList = list
            }).finally(()=>{
              this.loadingAcceptanceList = false
            })
          },
          getChecked(){
            if(this.applicationForm.exter.payMethod){
              this.sendData.checkedSettlement.push(this.applicationForm.exter.payMethod)
              this.sendData.paybillValue = this.applicationForm.exter.checkNumber
              if( this.applicationForm.exter.billStatus != null){
                this.sendData.billChecked = true
                this.sendData.billValue = this.applicationForm.exter.billStatus
              }
            }
          },
           setFormVale(formVal) {
            this.formValue = formVal
          },
          getData(item){
            this.applicationForm = {}
            this.acceptanceList = []
            if(item == null){
              this.applicationForm = Object.assign({},this.applyObj)
              // this.applicationForm = this.applyObj
            } else {
              this.applicationForm = item
            }
            this.getUserNameById(this.applicationForm.user)
            this.getSpPerson()
            this.getChecked()
            if(this.applicationForm.routeName =='applypayticketfandian'){
              this.getSecondPerson()
            }else {
              this.getSupplierContact()
            }
            // this.pay = this.applicationForm.totalExterAmount-this.applicationForm.deductPrice-this.applicationForm.price
            this.pay = Number(this.applicationForm.payment) - Number(this.applicationForm.price);
            if(this.applicationForm.routeName =='applypayticketmaipiao'){
              this.pay = this.pay - Number(this.applicationForm.deductPrice)    // 船上费用只有不开票的情况下才能抵扣，不开票都是走金琼
            }
            if(this.applicationForm.routeName == 'applypayticketmaipiao' || this.applicationForm.routeName == 'applypayticketdiancost' || this.applicationForm.routeName == 'applypayticket') {
              this.pay = this.pay - Number(this.applicationForm.dingjin)
            }
            if(this.applicationForm.routeName == 'applypayticketshippay' ) {
              // this.pay = this.pay - Number(this.applicationForm.dingjin)
            }
            this.pay = this.pay+Number(this.applicationForm.additionalPrice)
            this.initNum(this.pay)

            if(this.applicationForm.routeName =='applypayticketmaipiao'){
              if (!this.applicationForm.isApplyRecord) {
                if (this.applicationForm.deductPrice) {
                  this.applicationForm.remark = this.applicationForm.remark + ` 船上费用抵扣${this.applicationForm.deductPrice}元;`
                }
              }
            }

            if(this.applicationForm.routeName =='applypayticketmaipiao' || this.applicationForm.routeName =='applypayticketshippay' ||  this.applicationForm.routeName == 'applypayticketdiancost' || this.applicationForm.routeName =='applypayticket') {

              if (!this.applicationForm.isApplyRecord) {
                if (this.applicationForm.dingjin) {
                  this.applicationForm.remark = this.applicationForm.remark + ` 船舶定金抵扣${this.applicationForm.dingjin}元;`
                }
              }
            }
          },
          getSupplierContact(){
            var querydata = {
              supplierId:this.applicationForm.sysSupplierId
            }
            getSysSupplierContactList(querydata).then(res=>{
              if (res!=undefined&&res.resultCode === ERR_OK) {
                this.contractList = res.list
                if(res.list != null && res.list.length>0){
                  res.list.forEach(item => {
                    if(item.id === this.applicationForm.contractId){
                      this.contract = item
                    }
                  })
                }
              }
            })
          },
          getSecondPerson(){
            getPersonalListById(this.applicationForm.secondId).then(res=>{
              if (res!=undefined&&res.resultCode === ERR_OK) {
                this.contractList = res.list
                if(res.list != null && res.list.length>0){
                  res.list.forEach(item => {
                    if(item.id === this.applicationForm.contractId){
                      this.contract = item
                    }
                  })
                }
              }
            })
          },
          cleandata(){
            this.contractList = [],
            this.applicationForm={},
            this.contract={},
            this.pay=0,
              this.userName=null,
            this.priceNum={
                numQianWan:0,
                numBaiWan:0,
                numShiWan:0,
                numWan:0,
                numQian:0,
                numBai:0,
                numShi:0,
                numYuan:0,
                numJiao:0,
                numFen:0,
            },
            this.sendData={
                checkedSettlement:[],
                billChecked:false,
                billValue:null,
                paybillValue:null,
            }
          },
          initNum(num){
            num = round(num, 2)
            console.log(num);
            var last = num
            if(num.toString().split('.')[0].length <8){
              if(num.toString().split('.')[0].length <7){
                this.priceNum.numQianWan = ""
              } else {
                this.priceNum.numQianWan = "￥"
              }
            } else {
              this.priceNum.numQianWan = Math.floor(last/10000000)
              last = last%10000000
            }

            if(num.toString().split('.')[0].length <7){
              if(num.toString().split('.')[0].length <6){
                this.priceNum.numBaiWan = ""
              } else {
                this.priceNum.numBaiWan = "￥"
              }

            } else {
              this.priceNum.numBaiWan = Math.floor(last/1000000)
              last = last%1000000

            }

            if(num.toString().split('.')[0].length <6){
              if(num.toString().split('.')[0].length <5){
                this.priceNum.numShiWan =""
              } else {
                this.priceNum.numShiWan ="￥"
              }
            } else {
              this.priceNum.numShiWan = Math.floor(last/100000)
              last = last%100000

            }

            if(num.toString().split('.')[0].length <5){
              if(num.toString().split('.')[0].length <4){
                this.priceNum.numWan = ""
              } else {
                this.priceNum.numWan = "￥"
              }
            } else {
              this.priceNum.numWan = Math.floor(last/10000)
              last = last%10000

            }
            if(num.toString().split('.')[0].length <4){
              if(num.toString().split('.')[0].length <3){
                this.priceNum.numQian = ""
              } else {
                this.priceNum.numQian = "￥"
              }
            } else {
              this.priceNum.numQian = Math.floor(last/1000)
              last = last%1000

            }
            if(num.toString().split('.')[0].length <3){
              if(num.toString().split('.')[0].length <2){
                this.priceNum.numBai = ""
              } else {
                this.priceNum.numBai = "￥"
              }
            } else {
              this.priceNum.numBai = Math.floor(last/100)
              last = last%100

            }
            if(num.toString().split('.')[0].length <2){
              if(num.toString().split('.')[0].length <12){
                this.priceNum.numShi = ""
              } else {
                this.priceNum.numShi = "￥"
              }
            } else {
              this.priceNum.numShi = Math.floor(last/10)
              last = last%10

            }
            if(num.toString().split('.')[0].length <1){
              this.priceNum.numYuan = 0
            } else {
              this.priceNum.numYuan = Math.floor(last)
              last = last

            }
             // 计算小数点后边的数字
            if(num.toString().split('.')[1] != undefined){
              let jfen=num.toString().split('.')[1]
              if(num.toString().split('.')[1].length <1){
                this.priceNum.numJiao = 0
              } else {
                this.priceNum.numJiao = Math.floor(jfen.toString().substring(0,1))
              }
              if(num.toString().split('.')[1].length <2){
                this.priceNum.numFen = 0
              } else {
                // 截取前一位
                if(jfen.toString().length>1){
                  this.priceNum.numFen = Math.floor(jfen.toString().substring(1,2))
                } else {
                  this.priceNum.numFen = 0
                }
              }
            } else {
              this.priceNum.numJiao = 0
              this.priceNum.numFen = 0
            }
            // this.priceNum.numJiao = Math.floor(last*10)
            // last = ((last*10).toFixed(1)*10)%10
            //  if(last){
            //   last=last.toFixed(1)
            // }


            // this.priceNum.numFen = Math.floor(last)
          },
          revertNum(money){
            money = round(money, 2)
            var cnNums = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"); //汉字的数字
            var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
            var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
            var cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位
            var cnInteger = "整"; //整数金额时后面跟的字符
            var cnIntLast = "元"; //整型完以后的单位
            var maxNum = 999999999999999.9999; //最大处理的数字
            var IntegerNum; //金额整数部分
            var DecimalNum; //金额小数部分
            var ChineseStr = ""; //输出的中文金额字符串
            var parts; //分离金额后用的数组，预定义
            if (money == "") {
              return "";
            }
            money = parseFloat(money);
            if (money >= maxNum) {
              alert('超出最大处理数字');
              return "";
            }
            if (money == 0) {
              ChineseStr = cnNums[0] + cnIntLast + cnInteger;
              return ChineseStr;
            }
            money = money.toString(); //转换为字符串
            if (money.indexOf(".") == -1) {
              IntegerNum = money;
              DecimalNum = '';
            } else {
              parts = money.split(".");
              IntegerNum = parts[0];
              DecimalNum = parts[1].substr(0, 4);
            }
            if (parseInt(IntegerNum, 10) > 0) { //获取整型部分转换
              var zeroCount = 0;
              var IntLen = IntegerNum.length;
              for (var i = 0; i < IntLen; i++) {
                var n = IntegerNum.substr(i, 1);
                var p = IntLen - i - 1;
                var q = p / 4;
                var m = p % 4;
                if (n == "0") {
                  zeroCount++;
                } else {
                  if (zeroCount > 0) {
                    ChineseStr += cnNums[0];
                  }
                  zeroCount = 0; //归零
                  ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
                }
                if (m == 0 && zeroCount < 4) {
                  ChineseStr += cnIntUnits[q];
                }
              }
              ChineseStr += cnIntLast;
              //整型部分处理完毕
            }
            if (DecimalNum != '') { //小数部分
              var decLen = DecimalNum.length;
              for (var i = 0; i < decLen; i++) {
                var n = DecimalNum.substr(i, 1);
                if (n != '0') {
                  ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
                }
              }
            }
            if (ChineseStr == '') {
              ChineseStr += cnNums[0] + cnIntLast + cnInteger;
            } else if (DecimalNum == '') {
              ChineseStr += cnInteger;
            }
            return ChineseStr;
          },

          statusFmt(row,column,cellValue,index){
            return fmtDictionary(cellValue,this.dictionaryLists['bill_status']);
          },
          contractCompanyFmt(row,column,cellValue,index){
            return fmtDictionarySpare(cellValue,this.dictionaryLists['contract_company'],"spare1");
          },
          beforeCheckSettlement(event, item) {
            if (item.code === 3) {
              return false;
            }
            event.preventDefault();
            return true;
          },
          myFmtDateTime(cellValue,fmtstr){
            if(cellValue==undefined||cellValue==null||cellValue==''){
              return '--'
            }
            return dayjs(cellValue).format(fmtstr)
          },
        },

    }
</script>

<style scoped>
  .record-table >>> .el-checkbox__input.is-disabled+span.el-checkbox__label{
    color: #606266;
  }
  td{
    width: 5%;
    text-align: center;
    height: 25px;
    color: #606266;
  }
  .record-title{
    width: 100%;
    text-align: center;
    font-size: 1.2rem;
  }
  .record-table{
    width: 100%;
  }
  .table-title{
    width: 15%;
  }
  .td-func{
    width: 10%;
  }
  .td-address{
    width: 15%;
    text-align: right;
  }
  .td-checkbox{
    text-align: left;
  }
  .row-price{
    height: 20px;
  }
  .price-table{
    width: 100%;
  }
  .td-mar{
    width: 25%;
  }
  .checkInput{
    height: 15px;
    border-left: none;
    border-right: none;
    border-top: none;
    border-bottom: #A8A8A9 1px solid;
    text-align: center;
  }
  .checkInput2{
    width: 80px;
    height: 20px;
    border-left: none;
    border-right: none;
    border-top: none;
    border-bottom: #A8A8A9 1px solid;
    text-align: center;
  }

  .showpic{
    display: none;
  }
  .el-table >>> .selected-row, .el-table >>> .selected-row td{
    background: #deedff !important;
  }

  table >>> .el-checkbox.is-disabled span.el-checkbox__label.el-checkbox__label{
    font-weight: normal;
    color: #606266;
  }
  table >>> .el-checkbox__input.is-disabled .el-checkbox__inner.el-checkbox__inner,.el-table >>>  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner.el-checkbox__inner {
    border-color: #bdbdbd;
    background-color: transparent;
    border-radius: 0;
  }
  table >>> .el-checkbox__input.is-disabled.is-checked.is-checked .el-checkbox__inner::after {
    border-color: #606266;
    height: 18px;
    width: 7px;
    border-width: 3px;
    top: -7px;
    left: 2px;
  }
</style>
